import {Router} from 'next/router';
import KwObserver, {IObserver} from './observer';

type IRouterState =
  | 'routeChangeStart'
  | 'routeChangeComplete'
  | 'routeChangeError';
const observer = new KwObserver<IRouterState>();

export function addRouterObserver(state: IRouterState, ob: IObserver) {
  observer.addObserver(state, ob);
}
export function addOneTimeRouterObserver(state: IRouterState, ob: IObserver) {
  observer.addOneTimeObserver(state, ob);
}
export function removeRouterObserver(state: IRouterState, ob: IObserver) {
  observer.removeObserver(state, ob);
}
function notifyRouterState(state: IRouterState) {
  observer.notify(state);
}

Router.events.on('routeChangeComplete', () =>
  notifyRouterState('routeChangeComplete')
);
Router.events.on('routeChangeStart', () =>
  notifyRouterState('routeChangeStart')
);
Router.events.on('routeChangeError', () =>
  notifyRouterState('routeChangeError')
);
